<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_6"></a>Parable<a id="page_7"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch0009_part01.vue?4721e335